import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import PageHero from "@/components/layout/PageHero";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { Clock, IndianRupee, FileText, Check } from "lucide-react";

export default function VisaGuideDetail() {
  const { slug } = useParams();
  const [v, setV] = useState(null);
  useEffect(() => { api.get(`/visa-guides/${slug}`).then(({ data }) => setV(data)).catch(() => {}); }, [slug]);
  if (!v) return <div className="container-page py-20 text-center text-slate-500">Loading…</div>;

  return (
    <div data-testid={`visa-detail-${slug}`}>
      <PageHero kicker="Visa Guide" title={`${v.country} — ${v.visa_type}`} subtitle={v.summary} image={v.image} />
      <div className="container-page py-10">
        <Breadcrumbs items={[{ label: "Visa Guides", to: "/visa-guides" }, { label: v.country }]} />
        <div className="grid md:grid-cols-3 gap-8">
          <article className="md:col-span-2 prose-slate max-w-none">
            <h2 className="font-montserrat font-bold text-2xl mb-4 text-slate-900">Required Documents</h2>
            <ul className="space-y-2">
              {v.documents.map((d) => (
                <li key={d} className="flex items-start gap-2 text-slate-700"><Check size={16} className="text-brand mt-1 shrink-0" /> {d}</li>
              ))}
            </ul>
            <h2 className="font-montserrat font-bold text-2xl mt-8 mb-4 text-slate-900">Application Steps</h2>
            <ol className="space-y-3">
              {v.steps.map((s, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-700">
                  <span className="shrink-0 w-7 h-7 inline-flex items-center justify-center rounded-full bg-brand text-white text-xs font-bold">{i + 1}</span>
                  <span>{s}</span>
                </li>
              ))}
            </ol>
          </article>
          <aside className="space-y-3">
            <div className="bg-white border border-slate-200 rounded-2xl p-5 space-y-3">
              <div className="text-xs font-bold uppercase tracking-widest text-slate-500">At a Glance</div>
              <div className="flex items-center gap-2 text-sm text-slate-700"><Clock size={14} className="text-brand" /> {v.processing_time}</div>
              <div className="flex items-center gap-2 text-sm text-slate-700"><IndianRupee size={14} className="text-brand" /> {v.fees_inr}</div>
              <div className="flex items-center gap-2 text-sm text-slate-700"><FileText size={14} className="text-brand" /> Valid {v.validity}</div>
            </div>
            <Link to="/contact" className="block bg-brand text-white rounded-2xl p-5 text-center">
              <div className="font-montserrat font-bold">Need visa assistance?</div>
              <div className="text-sm text-white/85 mt-1">Talk to our partner agent</div>
            </Link>
          </aside>
        </div>
      </div>
    </div>
  );
}
